<template>
  <div :class="tabClasses" role="tablist">
    <button
      v-for="tab in tabs"
      v-on:click="changeTab(tab.index)"
      v-bind:class="[
        activeTab === tab.index
          ? theme === 'tabs'
            ? 'tabs__tab--active'
            : 'activeView'
          : '',
        tabsClasses,
      ]"
      role="tab"
      :aria-controls="controls"
      :aria-selected="activeTab === tab.index"
      v-html="tab.title"
    ></button>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";

const emit = defineEmits(["tab-changed"]);

const props = defineProps({
  tabs: {
    type: Array,
    default: [],
  },
  activeTabIndex: null,
  controls: {
    type: String,
    default: "",
  },
  theme: {
    type: String,
    default: "tabs",
  },
});

const activeTab = ref(null);

//lifecycle
onMounted(() => {
  activeTab.value = !props.activeTabIndex
    ? props.tabs[0].index
    : props.activeTabIndex;
});

//methods
const changeTab = function (index) {
  activeTab.value = index;
  emit("tab-changed", index);
};

//computed
const tabClasses = computed(() => {
  return props.theme === "tabs" ? ["tabs"] : ["inlineList"];
});
const tabsClasses = computed(() => {
  return props.theme === "tabs" ? ["tabs__tab"] : ["buttonLink"];
});
</script>

<style scoped lang="scss">
@import "../../styles/variables.scss";
.tabs {
  display: flex;
  margin-block-end: 2em;
  border-block-end: 1px solid $border-color;
  gap: 1em;
}
.tabs__tab {
  font-family: $font-family;
  border: none;
  border-block-end: 4px solid transparent;
  background: none;
  text-transform: uppercase;
  padding: 0.2em;
  font-size: 0.8em;
  font-weight: $bold-weight;
  margin-block-end: -1px;

  &:hover {
    border-block-end-color: $subtleTab__borderColor--active;
  }
}
.tabs__tab--active {
  border-block-end-color: $subtleTab__borderColor--active;
}
.tabs__tab--buttons {
}
</style>
